import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { ScheduledPaymentModel } from '@amfam/shared/models';
import { DateFormatPipe } from '@amfam/shared/ui/pipes';
import { DsTableUtilService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-future-payments',
  templateUrl: './future-payments.component.html',
  styleUrls: ['./future-payments.component.scss'],
  standalone: false
})
export class FuturePaymentsComponent implements OnInit {
  @ViewChild('headerCellTpl', { static: true }) headerCellTpl: TemplateRef<unknown>;
  @ViewChild('amtCellTpl', { static: true }) amtCellTpl: TemplateRef<unknown>;
  @ViewChild('dateCellTmpl', { static: true }) dateCellTmpl: TemplateRef<unknown>;

  rows = [];
  cssClasses = 'material noshadow ';
  columns = [];
  scheduledPayments: Array<ScheduledPaymentModel>;

  constructor(private tableUtil: DsTableUtilService) {}

  @Input()
  set scheduledpayments(value) {
    this.rows = [];
    this.scheduledPayments = value;
    this.buildRowsList();
  }

  getColumns() {
    this.columns = [
      {
        cellTemplate: this.dateCellTmpl,
        headerTemplate: this.headerCellTpl,
        isHeaderOnMobile: true,
        name: 'Due Date',
        shortName: 'Date',
        draggable: false,
        resizable: true,
        sortable: true,
        comparator: this.tableUtil.dateComparator.bind(this)
      },
      {
        cellTemplate: this.amtCellTpl,
        headerTemplate: this.headerCellTpl,
        isHeaderOnMobile: true,
        name: 'Amount Due',
        shortName: 'Amount',
        draggable: false,
        resizeable: true,
        sortable: true,
        marginRight: 0,
        comparator: this.tableUtil.nameComparator.bind(this)
      }
    ];
  }

  ngOnInit() {
    this.getColumns();
  }

  private buildRowsList() {
    if (this.scheduledPayments) {
      this.scheduledPayments.forEach(row => {
        // get the actual date with the timezone offset
        row.dueDate = new DateFormatPipe().transform(row.dueDate, 'MM/DD/YYYY');
        this.rows.push({
          minimumAmountDue: row.amount,
          paymentDueDate: row.dueDate
        });
      });
    }
  }
}
